"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _reactIntersectionObserver = require("react-intersection-observer");
var _constants = require("../constants");
var Avatar = function Avatar(_ref) {
  var initials = _ref.initials,
    image = _ref.image,
    avatarType = _ref.avatarType,
    avatarSize = _ref.avatarSize,
    avatarColor = _ref.avatarColor,
    avatarNotification = _ref.avatarNotification,
    notificationText = _ref.notificationText,
    className = _ref.className,
    disabled = _ref.disabled,
    countryCode = _ref.countryCode;
  if (image) {
    var _useInView = (0, _reactIntersectionObserver.useInView)({
        rootMargin: _constants.LAZY_LOAD_OFFSET,
        triggerOnce: true
      }),
      ref = _useInView.ref,
      inView = _useInView.inView;
    return /*#__PURE__*/_react["default"].createElement("div", {
      ref: ref,
      className: (0, _classnames["default"])('d8-c-avatar', 'flex-shrink-0', avatarType || _constants.AVATAR_TYPES.CIRCLE, avatarSize || _constants.AVATAR_SIZES.MEDIUM, avatarColor || _constants.AVATAR_COLORS.PRIMARY, className)
    }, disabled && /*#__PURE__*/_react["default"].createElement("div", {
      className: "overlay"
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: "aspect-1-1"
    }, /*#__PURE__*/_react["default"].createElement("img", {
      src: inView ? image.url : '',
      className: "avatar-image",
      alt: image.alt
    })), avatarNotification && /*#__PURE__*/_react["default"].createElement("span", {
      className: "avatar-notification ".concat(avatarNotification)
    }), notificationText && /*#__PURE__*/_react["default"].createElement("span", {
      className: "avatar-notification text-center d8-u-color-contrast-high ".concat(_constants.AVATAR_NOTIFICATION.TEXT)
    }, notificationText), countryCode && /*#__PURE__*/_react["default"].createElement("img", {
      className: "avatar-flag",
      src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(countryCode, ".svg"),
      alt: "countryCode flag"
    }));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])('d8-c-avatar', 'flex-shrink-0', avatarType || _constants.AVATAR_TYPES, avatarSize || _constants.AVATAR_SIZES, avatarColor || _constants.AVATAR_COLORS, className)
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-color-white avatar-initials"
  }, initials), avatarNotification && /*#__PURE__*/_react["default"].createElement("span", {
    className: "avatar-notification ".concat(avatarNotification)
  }), notificationText && /*#__PURE__*/_react["default"].createElement("span", {
    className: "avatar-notification text-center d8-u-color-contrast-high ".concat(_constants.AVATAR_NOTIFICATION.TEXT)
  }, notificationText), countryCode && /*#__PURE__*/_react["default"].createElement("img", {
    className: "avatar-flag",
    src: "http://purecatamphetamine.github.io/country-flag-icons/3x2/".concat(countryCode, ".svg"),
    alt: "countryCode flag"
  }));
};
Avatar.propTypes = {
  initials: _propTypes["default"].string,
  image: _propTypes["default"].object,
  avatarType: _propTypes["default"].string,
  avatarSize: _propTypes["default"].string,
  avatarColor: _propTypes["default"].string,
  avatarNotification: _propTypes["default"].string,
  className: _propTypes["default"].string,
  notificationText: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  disabled: _propTypes["default"].bool,
  countryCode: _propTypes["default"].string
};
Avatar.defaultProps = {
  avatarType: _constants.AVATAR_TYPES.CIRCLE,
  initials: 'ME',
  avatarSize: _constants.AVATAR_SIZES.MEDIUM,
  avatarColor: _constants.AVATAR_COLORS.PRIMARY,
  avatarNotification: null,
  notificationText: null
};
var _default = exports["default"] = Avatar;